
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8E8E92","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M21.397 2H.603A.612.612 0 000 2.62v13.856c0 .336.27.62.603.62h7.418a.61.61 0 01.603.614v1.893c0 .342.245.49.54.335l1.302-.704c.295-.155.78-.155 1.075 0l.823.447.478.257c.27.143.496.026.528-.257.006-.026.006-.052.006-.078V17.71a.61.61 0 01.603-.613h7.418a.617.617 0 00.603-.62V2.62c0-.343-.27-.62-.603-.62zM2.299 15.714a.612.612 0 01-.607-.6v-10.8c0-.33.278-.6.607-.6h7.248a.6.6 0 01.607.6v10.8c0 .169-.076.33-.196.437a.592.592 0 01-.41.163H2.298zm18.009-.6a.608.608 0 01-.607.6h-7.254a.603.603 0 01-.6-.6v-10.8c0-.33.265-.6.6-.6H19.7c.335 0 .607.27.607.6v10.8z"}}),_c('path',{attrs:{"d":"M8 10.497a.46.46 0 01-.218.377.703.703 0 01-.41.126H4.635c-.35 0-.635-.225-.635-.503 0-.198.145-.371.364-.45a.74.74 0 01.27-.047h2.738c.159 0 .297.042.41.126.132.084.218.22.218.371M8 8.497a.46.46 0 01-.218.377.728.728 0 01-.417.126H4.628C4.284 9 4 8.775 4 8.497 4 8.22 4.284 8 4.628 8h2.737c.159 0 .304.048.417.126.132.089.218.22.218.371M19 10.497a.462.462 0 01-.224.383.742.742 0 01-.41.12h-2.732a.742.742 0 01-.41-.12.462.462 0 01-.224-.383c0-.146.08-.277.205-.36a.437.437 0 01.171-.09.692.692 0 01.258-.047h2.732c.159 0 .297.042.41.12a.451.451 0 01.224.377M19 8.497a.46.46 0 01-.218.377.707.707 0 01-.41.126h-2.737a.726.726 0 01-.45-.146.475.475 0 01-.185-.357c0-.161.093-.303.245-.392a.729.729 0 01.39-.105h2.737a.71.71 0 01.41.126c.132.089.218.22.218.371"}})])])
          )
        }
      }
    